<template>
    <div :class="containerClass">
        <label v-if="labelStatus"
            class="fw-bold"
            :for="id" 
            :style="inputLable"
            >{{ label }}
            <span v-if="required" class="required-fields">*</span>
        </label>
        <input
            :id="id"
            class="form-control"
            :placeholder="placeholderMsg"
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
            :type="type"
            :autocomplete="autocomplete"
            :maxlength="maxlength"
            :disabled="disabled"
        />
        <span v-if="required && errorStatus && modelValue.length === 0" 
            class="text-danger mt-1" 
            :style="inputErrorMsg"
            >Enter {{ label }}
        </span>
    </div>
</template>

<script>

export default {
    name: "BaseInput",
    props: {
        label: {
            type: String,
            default: "text",
        },
        value: {
            type: [String, Number, Boolean],
            default: "",
        },
        attributes: {
            type: Object,
            default: () => ({}),
        },
        modelValue: {
            type: [String, Number],
            default: "",
        },
        id: {
            type: String,
            default: "",
        },
        colClass: {
            type: String,
            default: "col-md-auto",
        },
        required: {
            type: Boolean,
            default: true,
        },
        type: {
            type: String,
            default: "text",
        },
        autocomplete: {
            type: String,
            default: "off",
        },
        inputLable: {
            type: Object,
            default: () => ({
                fontSize: '14px',
            }),
        },
        inputErrorMsg: {
            type: Object,
            default: () => ({
                fontSize: '10px'
            }),
        },
        errorStatus: {
            type: Boolean,
            default: false
        },
        marginTop: {
            type: String,
            default: "mt-3",
        },
        maxlength: {
            type: [String, Number],
            default: '',
        },
        labelStatus: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false
        },
        isShow: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        containerClass() {
            const isEnable = this.isShow === true ? 'd-block' : 'd-none';
            console.log('isEnable', isEnable)
            return `${this.colClass} ${this.marginTop} ${isEnable}`;
        },
        placeholderMsg() {
            return `Enter ${this.label.toLowerCase()}`;
        }
    },
    methods: {
    },
};
</script>
<style scoped>
    .required-fields {
        color: red;
    }
    input[type="number"]::-webkit-outer-spin-button,
        input[type="number"]::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

    
</style>